import moment from 'moment'

export function weekdays (locale, mondayFirst = false) {
  let weekdays = moment.localeData(locale).weekdaysMin()

  if (mondayFirst) {
    weekdays.push(weekdays.shift())
  }

  return weekdays
}

export function monthDays (month, year, mondayFirst = false) {
  const monthDate = moment([year, month, 1])
  let firstDay = monthDate.day() - (mondayFirst ? 1 : 0)

  if (firstDay === -1) {
    firstDay = 6
  }

  let days = (new Array(monthDate.daysInMonth() + firstDay)).fill(null)

  return days.map((value, index) => {
    return index + 1 < firstDay ? null : index + 1 - firstDay
  })
}

export function years () {
  const currentYear = moment().year()
  let years = []

  for (let i = currentYear - 100; i < currentYear + 100; i++) {
    years.push(i)
  }

  return years
}

export function hours () {
  let hours = []

  for (let i = 0; i < 24; i++) {
    if(i < 8 || i > 20 ){
      continue
    }
    hours.push(i < 10 ? '0' + i : i)
  }

  return hours
}

export function minutes () {
  let minutes = []

  for (let i = 0; i < 60; i += 10) {
    minutes.push(i < 10 ? '0' + i : i)
  }

  return minutes
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/datetimepicker/util.js